import { computed, Injectable, signal } from '@angular/core';

import type { ExportDocumentKind, ExportFormat, ExportPhase } from './models/export.types';

export interface ExportProgressState {
  active: boolean;
  phase: ExportPhase | null;
  format: ExportFormat | 'html' | 'print' | null;
  documentKind: ExportDocumentKind | null;
}

@Injectable({ providedIn: 'root' })
export class ExportProgressService {
  private readonly state = signal<ExportProgressState>({
    active: false,
    phase: null,
    format: null,
    documentKind: null,
  });

  readonly progress = this.state.asReadonly();
  readonly isActive = computed(() => this.state().active);

  start(
    phase: ExportPhase,
    options?: { format?: ExportFormat | 'html' | 'print'; documentKind?: ExportDocumentKind },
  ): void {
    this.state.set({
      active: true,
      phase,
      format: options?.format ?? null,
      documentKind: options?.documentKind ?? null,
    });
  }

  setPhase(phase: ExportPhase): void {
    this.state.update((s) => (s.active ? { ...s, phase } : s));
  }

  end(): void {
    this.state.set({
      active: false,
      phase: null,
      format: null,
      documentKind: null,
    });
  }
}
